import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import App from 'antd/lib/app';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import { createApiKey, fetchApiKeys, revokeApiKey } from './index';
import { IApiKey, IApiKeyCreated, ICreateApiKey } from './interface';

export const useApiKeysQuery = (options = {}) => {
    return useQuery<IPagination<IApiKey>, Error>({
        queryKey: [QueryKey.API_KEYS],
        queryFn: ({ signal }) => fetchApiKeys(signal),
        ...options,
    });
};

export const useCreateApiKeyMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<IApiKeyCreated, Error, ICreateApiKey>(createApiKey, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.API_KEYS]);
            notification.success({ key: 'create-api-key-success', message: 'API key created successfully' });
        },
        onError: error => {
            notification.error({ key: 'create-api-key-error', message: error.message || 'Cannot create API key!' });
        },
    });
};

export const useRevokeApiKeyMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>(revokeApiKey, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.API_KEYS]);
            notification.success({ key: 'revoke-api-key-success', message: 'API key revoked successfully' });
        },
        onError: error => {
            notification.error({ key: 'revoke-api-key-error', message: error.message || 'Cannot revoke API key!' });
        },
    });
};
